class Player {
    name = '';

    constructor(name = '') {
        this.name = name;
    }
}

export default Player;